import script from "./CalendaryIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendaryIcon.vue?vue&type=script&setup=true&lang=js"

import "./CalendaryIcon.vue?vue&type=style&index=0&id=15050c9f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15050c9f"]])

export default __exports__